<template>
  <div ref="gameContent" class="game-content no-margin" :class="ENAME">
    <!-- 遮罩开始 -->
    <transition name="fade">
      <em class="mask" v-show="asidePopupState || asideTiktokPageState"></em>
    </transition>
    <!-- 遮罩结束 -->

    <!-- 研发游戏界面开始 -->
    <iframe
      v-if="!!tiktokGameLink"
      ref="curGamePage"
      id="game-iframe"
      class="iframe j-gamepage-iframe"
      title=""
      :src="tiktokGameLink"
      @load="gameLoad"
    ></iframe>
    <!-- 研发游戏界面结束 -->

    <!-- 用户中心侧拉栏开始 -->
    <transition name="slide-up">
      <TiktokAsidePopup v-if="asidePopupState">
        <template>
          <TiktokUserCenter></TiktokUserCenter>
        </template>
      </TiktokAsidePopup>
    </transition>
    <!-- 用户中心侧拉栏结束 -->

    <!-- 自定义页面侧拉栏开始 -->
    <transition name="slide-up">
      <TiktokAsidePopup v-if="asideTiktokPageState">
        <template>
          <TiktokWebviewPage :link="asideTiktokPageLink"></TiktokWebviewPage>
        </template>
      </TiktokAsidePopup>
    </transition>
    <!-- 自定义页面侧拉栏结束 -->

    <!-- 提示框开始 -->
    <transition name="fade">
      <template>
        <TipsCommon v-show="commonTipsContent"></TipsCommon>
      </template>
    </transition>
    <!-- 提示框结束 -->

    <!-- 弹屏 -->
    <transition name="fade">
      <template v-if="isOpenTca">
        <div v-show="tpShow">
          <TpIframe
            :tpLink="tpLink"
            :tpInitInfo="tpInitInfo"
            @hideTpPopup="hideTp"
            @showTp="showTp"
            :pcIsHorizontal="pcIsHorizontal"
            :mobileIsLandscape="mobileIsLandscape"
          ></TpIframe>
        </div>
      </template>
    </transition>

    <!-- tca全局loading -->
    <transition name="fade">
      <div class="loading-mask" v-if="showTcaLoading">
        <div class="load">
          <em class="loading load1"></em>
          <em class="loading load2"></em>
          <em class="loading load3"></em>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import globalConfig from '../utiles/globalConfig'
import Init from '../mixins/Init'
import SdkListener from '../mixins/SdkListener'
import Platform from '../mixins/Platform'
import Tca from '../mixins/Tca'
import Tanping from '../mixins/Tanping'
import TiktokAsidePopup from './commission/TiktokAsidePopup'
import TipsCommon from './commission/TipsCommon'
import TiktokUserCenter from './commission/TiktokUserCenter'
import TiktokWebviewPage from './commission/TiktokWebviewPage'
import TpIframe from './tanping/TpIframe'

export default {
  name: 'TiktokIframe',
  mixins: [Init, SdkListener, Platform, Tca, Tanping],
  components: {
    TiktokAsidePopup,
    TiktokUserCenter,
    TiktokWebviewPage,
    TpIframe,
    TipsCommon
  },
  data() {
    return {
      ENAME: window.gameInfo.ENNAME,
      menuBottom: Math.ceil(
        Number(globalConfig.getHrefParam('menuBottom') || 0) /
          (window.devicePixelRatio || 1)
      ),
      tiktokGameLink:
        globalConfig.getHrefParam('test') == 1
          ? window.pageInfo.thirdPlatformConfig.tiktok.sandboxGameLink
          : window.pageInfo.thirdPlatformConfig.tiktok.productGameLink
    }
  },
  computed: {
    ...mapGetters([
      'asidePopupState',
      'asideTiktokPageState',
      'asideTiktokPageLink',
      'commonTipsContent'
    ])
  },
  created() {
    // 判断是否是开发环境
    if (process.env.NODE_ENV === 'development') {
      this.loginTiktok()
    }
  },
  mounted() {
    this.setGlobalEvent()
    this.setGlobalStyle()
  },
  methods: {
    setGlobalEvent() {
      document.addEventListener(
        'touchmove',
        e => {
          e.preventDefault()
        },
        { passive: false }
      )
    },
    setGlobalStyle() {
      try {
        if (process.env.NODE_ENV === 'development') {
          document.body.setAttribute('style', 'font-size: 0;')
        }
        const style = `
          overflow: hidden;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100vw;
          height: 100vh;`

        document.querySelector('html').setAttribute('style', style)
        document.body.setAttribute('style', style)
      } catch (e) {
        this.sendMessageToTiktok('tiktok_log', {
          logValue: e.toString()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('../assets/scss/gameIframe.scss');

.game-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
